<div class="accordion-tab" *ngIf="isBrowser" [ngClass]="{ 'streaming-panel': streamingEnabled, 'mb-3': !isHomepage || !showCarousel }">
  <p-accordion *ngIf="streamingEnabled; else legacyPlayer" (onClose)="onTabClose()" (onOpen)="onTabOpen()">
    <p-accordionTab>
      <ng-template pTemplate="header">
        <span class="stream-heading">
          <span class="stream-heading-title">
            <span class="stream-heading-dot" [class.is-live]="hasLiveMeetings" aria-hidden="true"></span>
            <img class="stream-heading-logo" src="assets/media/channels-icon/channel-logo.webp" [alt]="'MENU.STREAMING' | translate" width="100" height="29" decoding="async" />
            <span class="sr-only" *ngIf="hasLiveMeetings">{{ 'STREAMING.LIVE' | translate }}</span>
          </span>
          <span class="stream-heading-selection">{{ selectedLabel || ((selectedId || selectedLegacyUrl ? 'STREAMING.CHANNEL' : 'STREAMING.PMU') | translate) }}</span>
          <span class="stream-heading-action">{{ (panelOpen ? 'STREAMING.HIDE' : 'STREAMING.SHOW') | translate }}</span>
        </span>
      </ng-template>

      <div class="stream-content">
        <div class="video-frame">
          <iframe *ngIf="channelEmbedType === 'iframe' && panelOpen" [src]="iframeUrl"
            [title]="'STREAMING.VIDEO' | translate" allow="autoplay; fullscreen" allowfullscreen></iframe>
          <video #streamVideo class="stream-video" [hidden]="channelEmbedType === 'iframe'" controls preload="none" playsinline webkit-playsinline
            (loadeddata)="onVideoReady()" (error)="onVideoError()" [attr.aria-label]="'STREAMING.VIDEO' | translate"></video>
          <div class="connecting-notice" *ngIf="playbackLoading && !playbackError && !userPaused && !autoplayBlocked" role="status">
            <span>{{ (playbackRetrying ? 'STREAMING.RECONNECTING' : 'STREAMING.CONNECTING') | translate }}</span>
            <button type="button" (click)="togglePlaybackIntent()">{{ 'STREAMING.PAUSE' | translate }}</button>
          </div>
          <div class="playback-intent" *ngIf="!playbackError && (userPaused || autoplayBlocked)">
            <button type="button" (click)="togglePlaybackIntent()">
              <span class="chip-play" aria-hidden="true"></span>{{ (autoplayBlocked ? 'STREAMING.TAP_TO_PLAY' : 'STREAMING.RESUME') | translate }}
            </button>
          </div>
          <div class="playback-error" *ngIf="playbackError" role="alert">
            <span>{{ playbackError | translate }}</span>
            <div class="playback-actions">
              <button type="button" (click)="retryPlayback()">{{ 'STREAMING.RETRY' | translate }}</button>
              <button type="button" (click)="selectPublicStream()">{{ 'STREAMING.BACK_TO_PMU' | translate }}</button>
            </div>
          </div>
        </div>

        <div class="stream-picker">
          <div #meetingRail class="meeting-rail" role="group" [attr.aria-label]="'STREAMING.CHOOSE_TRACK' | translate">
            <button type="button" class="stream-chip pmu-chip" (click)="selectPublicStream()"
              [class.is-selected]="!selectedId && !selectedLegacyUrl" [attr.aria-pressed]="!selectedId && !selectedLegacyUrl"
              [attr.aria-label]="'STREAMING.PMU' | translate" [title]="'STREAMING.PMU' | translate">
              <img class="pmu-logo" src="assets/media/channels-icon/channel-1.webp" alt="" width="52" height="26" />
              <span class="chip-play" aria-hidden="true"></span>
            </button>
            <button type="button" class="stream-chip" *ngFor="let meeting of visibleMeetings; trackBy: trackById"
              (click)="selectReunion(meeting.id, meeting.playable)" [disabled]="!meeting.playable"
              [class.is-selected]="selectedId === meeting.id" [attr.aria-pressed]="selectedId === meeting.id">
              <span class="reunion-badge" *ngIf="meeting.reunionNumber !== null">{{ 'STREAMING.REUNION_SHORT' | translate }}{{ meeting.reunionNumber }}</span>
              <span class="chip-copy">
                <span class="chip-label">{{ meeting.label || meeting.trackName }}</span>
                <span class="chip-time" [class.confirmed-live]="confirmedLive(meeting)" *ngIf="meetingTime(meeting) as timing">
                  <ng-container *ngIf="meetingRace(meeting) as race"><span *ngIf="race.number !== null && timing.key !== 'STREAMING.FINISHED' && timing.key !== 'STREAMING.SHORT_UNAVAILABLE' && timing.key !== 'STREAMING.COVERAGE'">{{ 'STREAMING.RACE_SHORT' | translate }}{{ race.number }} · </span></ng-container>{{ timing.key | translate: timing }}
                </span>
              </span>
            </button>
          </div>
          <button type="button" class="other-toggle" *ngIf="legacyChannels.length"
            (click)="otherStreamsOpen = !otherStreamsOpen" [attr.aria-expanded]="otherStreamsOpen"
            [attr.aria-label]="'STREAMING.OTHER_STREAMS' | translate" [title]="'STREAMING.OTHER_STREAMS' | translate">
            <span class="other-label">{{ 'STREAMING.OTHER_STREAMS' | translate }}</span><span class="other-dots" aria-hidden="true">⋯</span>
          </button>
        </div>

        <div class="other-streams" *ngIf="otherStreamsOpen && legacyChannels.length" role="group" [attr.aria-label]="'STREAMING.OTHER_STREAMS' | translate">
          <button type="button" class="stream-chip" *ngFor="let channel of legacyChannels; let index = index"
            (click)="startVideo(channel.channelStreamSource, channel.channelEmbedType)"
            [class.is-selected]="selectedLegacyUrl === channel.channelStreamSource" [attr.aria-pressed]="selectedLegacyUrl === channel.channelStreamSource">
            {{ channel.channelName || channel.name || ('STREAMING.CHANNEL_NUMBER' | translate: { number: index + 2 }) }}
          </button>
        </div>

        <ng-container *ngIf="canSeeReunions">
          <div class="stream-notice" *ngIf="guideLoading && !guide" role="status">{{ 'STREAMING.LOADING' | translate }}</div>
          <div class="stream-notice" *ngIf="guideFailed || guide?.stale" role="status">
            <span>{{ (guide ? 'STREAMING.STALE' : 'STREAMING.GUIDE_ERROR') | translate }}</span>
            <button type="button" (click)="retryGuide()">{{ 'STREAMING.RETRY' | translate }}</button>
          </div>
          <div class="stream-notice" *ngIf="guide && !guide.enabled">{{ 'STREAMING.DISABLED' | translate }}</div>
          <div class="stream-notice" *ngIf="selectedMissing">{{ 'STREAMING.SELECTION_CHANGED' | translate }}</div>
          <div class="stream-notice" *ngIf="sharedSignalLabel">
            {{ 'STREAMING.SHARED_SIGNAL' | translate: { meeting: sharedSignalLabel } }}
          </div>
        </ng-container>
        <details class="playback-diagnostics" *ngIf="diagnosticsEnabled">
          <summary>{{ 'STREAMING.DIAGNOSTICS' | translate }}</summary>
          <button type="button" (click)="copyPlaybackReport(playbackReport)">{{ 'STREAMING.COPY_DIAGNOSTICS' | translate }}</button>
          <p>{{ 'STREAMING.DIAGNOSTICS_HELP' | translate }}</p>
          <textarea #playbackReport readonly rows="6" [value]="diagnosticText"
            [attr.aria-label]="'STREAMING.DIAGNOSTICS' | translate" spellcheck="false"></textarea>
        </details>
      </div>
    </p-accordionTab>
  </p-accordion>
  <!-- Streaming disabled (no streaming environment key): the player and channel
       carousel exactly as before the feature. The same engine and recovery drive
       this video, so it binds the same two media events as the compact player. -->
  <ng-template #legacyPlayer>
    <p-accordion class="text-center" (onClose)="onTabClose()" (onOpen)="onTabOpen()">
      <p-accordionTab header="{{ 'MENU.STREAMING' | translate }}">
        <div *ngIf="channelEmbedType === 'iframe'" style="width:100.01%; height: 484px;">
          <iframe [src]="iframeUrl" style="border: none" width="100%" height="100%">
          </iframe>
        </div>

        <div [ngStyle]="{
            display: channelEmbedType !== 'iframe' ? 'block' : 'none'
          }">
          <video #streamVideo class="stream-video" controls preload="auto" playsinline webkit-playsinline
            (loadeddata)="onVideoReady()" (error)="onVideoError()"></video>
        </div>

        <div class="container-fluid bg-black streaming-carousel">
          <div class="row justify-content-around py-4">
            <p-carousel [value]="channels" [circular]="true" [numVisible]="5" [numScroll]="1"
              [responsiveOptions]="responsiveOptions" [indicatorsContentClass]="'d-none'">
              <ng-template let-channel pTemplate="image">
                <a class="c-p" (click)="
                    startVideo(
                      channel?.channelStreamSource,
                      channel?.channelEmbedType
                    )
                  ">
                  <img class="channel-img rounded-lg" [src]="channel?.channelIcon" />
                </a>
              </ng-template>
            </p-carousel>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </ng-template>
  <div *ngIf="isBrowser && showCarousel && isHomepage && visibleSliders?.length" [@enterAnimation] class="hideArrow">
    <p-carousel [value]="visibleSliders" [autoplayInterval]="5000" [circular]="true">
      <ng-template let-slide pTemplate="image">
        <a [ngStyle]="{ cursor: slide.page_url ? 'pointer' : 'default' }"
          [routerLink]="slide.page_url ? 'race/' + slide.page_url : '/'">
          <img class="img-fluid" [src]="slide.image_url" [alt]="slide.alt | translateDataByLanguage" />
        </a>
      </ng-template>
    </p-carousel>
  </div>
</div>
